// extracted by mini-css-extract-plugin
export default {"content":"Content-module__content__AQSkW"};